"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineTableFieldCells = void 0;
const inline_autocomplete_cell_1 = require("./cells/inline-autocomplete-cell");
const inline_select_cell_1 = require("./cells/inline-select-cell");
const inline_text_field_cell_1 = require("./cells/inline-text-field-cell");
const inline_number_field_cell_1 = require("./cells/inline-number-field-cell");
const inline_date_field_cell_1 = require("./cells/inline-date-field-cell");
const inline_checkbox_cell_1 = require("./cells/inline-checkbox-cell");
exports.InlineTableFieldCells = {
    useInlineAutocompleteCellFactory: inline_autocomplete_cell_1.useInlineAutocompleteCellFactory,
    useInlineSelectCellFactory: inline_select_cell_1.useInlineSelectCellFactory,
    useInlineTextFieldFactory: inline_text_field_cell_1.useInlineTextFieldFactory,
    useInlineNumberFieldFactory: inline_number_field_cell_1.useInlineNumberFieldFactory,
    useInlineDateFieldFactory: inline_date_field_cell_1.useInlineDateFieldFactory,
    useInlineCheckboxFactory: inline_checkbox_cell_1.useInlineCheckboxFactory,
};
//# sourceMappingURL=inline-table-field-cells.js.map